var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item",class:{'bold': _vm.bold},on:{"click":_vm.onPath}},[_c('div',{staticClass:"menu-text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"menu-icon"},[_c('i',{class:_vm.iconImg})])])
}
var staticRenderFns = []

export { render, staticRenderFns }